import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-screen w-screen overflow-hidden bg-white"
    >
      {/* Logo watermark — fills the screen edge to edge */}
      <motion.div
        initial={{ opacity: 0, scale: 1.04 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 pointer-events-none"
      >
        <img
          src="/jay-ink-logo.png"
          alt="JAY-INK Academy emblem"
          draggable={false}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-auto h-auto min-w-full min-h-full max-w-none object-cover select-none"
          style={{ width: "max(100vw, 100vh)", height: "max(100vw, 100vh)" }}
        />
      </motion.div>

      {/* Top corner labels */}
      <div className="absolute top-24 md:top-28 left-6 md:left-12 right-6 md:right-12 flex justify-between items-center text-[#0A0A0A]/70 z-20">
        <div className="text-[10px] md:text-xs tracking-[0.4em] uppercase">EST. SYDNEY</div>
        <div className="hidden md:block text-[10px] tracking-[0.4em] uppercase">
          PADDINGTON · BONDI BEACH
        </div>
      </div>

      {/* Centered brand wordmark — exact typography from brand PDF */}
      <div className="relative z-10 h-full w-full flex items-center justify-center px-6">
        <h1 className="w-[88%] sm:w-[78%] md:w-[68%] lg:w-[58%] max-w-[1200px] m-0">
          <motion.img
            src="/jay-ink-wordmark.png"
            alt="JAY-INK Academy — Micro Realism, Fine Line and Black & Grey Tattoo Studio in Sydney"
            draggable={false}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
            data-testid="hero-title"
            className="w-full h-auto select-none"
          />
        </h1>
      </div>

      {/* Bottom CTA + tagline */}
      <div className="absolute bottom-8 md:bottom-12 left-0 right-0 z-10 px-6 md:px-12">
        <div className="max-w-[1600px] mx-auto flex justify-end">
          <motion.a
            href="#booking"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.9 }}
            data-testid="hero-book-button"
            className="group inline-flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase font-medium text-[#0A0A0A] border-b border-[#0A0A0A] pb-2 hover:gap-5 transition-all"
          >
            Book a consultation
            <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </motion.a>
        </div>
      </div>
    </section>
  );
}
